// SpyfallHost.jsx
// Props:
//   phase       : { phase, round, max_rounds, asker, target, question, order, asker_idx, players_total, seconds } | null
//   voteData    : { votes, vote_counts, voted, total } | null
//   result      : { spy, location, spy_caught, spy_guessed, early, votes, vote_counts, scores, round, max_rounds } | null
//   players     : object[]
//   scores      : object
//   tv          : bool

const COLOR = "#7b3dd5";
const SPY_COLOR = "#ff3355";

function Timer({ seconds, total }) {
  if (!seconds) return null;
  const pct = Math.min(100, (seconds / total) * 100);
  const color = seconds <= 5 ? SPY_COLOR : COLOR;
  return (
    <div style={{ width: "100%", height: 8, background: "#ffffff15", borderRadius: 4, overflow: "hidden", marginTop: 8 }}>
      <div style={{ width: `${pct}%`, height: "100%", background: color, borderRadius: 4, transition: "width 1s linear" }} />
    </div>
  );
}

export default function SpyfallHost({ phase, voteData, result, players, scores, tv }) {

  // ── Результат раунда ──────────────────────────────────────────────────────
  if (result) {
    const { spy, location, spy_caught, spy_guessed, early, vote_counts } = result;
    let headline, sub, emoji;
    if (spy_caught) {
      headline = `${spy} был шпионом! 🕵️`;
      sub = "Мирные победили!";
      emoji = "🎉";
    } else if (spy_guessed) {
      headline = `Шпион угадал! Это было — ${location?.name}`;
      sub = early ? "Досрочная угадка! +300 шпиону" : "Шпион угадал локацию! +200 шпиону";
      emoji = "🕵️";
    } else {
      headline = `Шпиона не поймали! Он не угадал локацию`;
      sub = `Локация была: ${location?.emoji} ${location?.name}`;
      emoji = "🌍";
    }

    return (
      <div className="w-full animate-slide-up" style={{ display: "flex", flexDirection: "column", gap: tv ? "1.5rem" : "1rem" }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: tv ? "4rem" : "2.5rem" }}>{emoji}</div>
          <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: tv ? "2rem" : "1.3rem", color: "#fff", textShadow: "2px 2px 0 #000", marginTop: 8 }}>
            {headline}
          </div>
          <div style={{ fontFamily: "'Nunito',sans-serif", fontSize: tv ? "1.2rem" : "0.85rem", color: "#aaa", marginTop: 6 }}>
            {sub}
          </div>
        </div>

        {/* Локация */}
        <div style={{
          background: "#1a0535", border: `3px solid ${COLOR}55`, borderRadius: "1.25rem",
          padding: tv ? "1.5rem 2rem" : "1rem 1.25rem", textAlign: "center", maxWidth: 500, margin: "0 auto", width: "100%",
        }}>
          <div style={{ fontSize: tv ? "3rem" : "2rem" }}>{location?.emoji}</div>
          <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: tv ? "1.8rem" : "1.1rem", color: "#fff", marginTop: 4 }}>
            {location?.name}
          </div>
          <div style={{ fontFamily: "'Nunito',sans-serif", fontSize: tv ? "1rem" : "0.75rem", color: "#888", marginTop: 4 }}>
            {location?.description}
          </div>
        </div>

        {/* Голоса */}
        {vote_counts && Object.keys(vote_counts).length > 0 && (
          <div style={{ maxWidth: 500, margin: "0 auto", width: "100%" }}>
            <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: tv ? "1rem" : "0.8rem", color: "#888", marginBottom: 8, textAlign: "center" }}>
              Итоги голосования
            </div>
            {Object.entries(vote_counts).sort((a, b) => b[1] - a[1]).map(([name, cnt]) => (
              <div key={name} style={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                background: name === spy ? "#ff335522" : "#ffffff08",
                border: `1.5px solid ${name === spy ? "#ff3355" : "#ffffff15"}`,
                borderRadius: "0.75rem", padding: tv ? "0.6rem 1rem" : "0.4rem 0.75rem",
                marginBottom: 6,
              }}>
                <span style={{ fontFamily: "'Fredoka One',sans-serif", color: name === spy ? "#ff3355" : "#fff", fontSize: tv ? "1.1rem" : "0.85rem" }}>
                  {name === spy ? "🕵️ " : ""}{name}
                </span>
                <span style={{ fontFamily: "'Fredoka One',sans-serif", color: "#ffe600", fontSize: tv ? "1.2rem" : "0.9rem" }}>
                  {cnt} {cnt === 1 ? "голос" : cnt < 5 ? "голоса" : "голосов"}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  if (!phase) return null;

  // ── Раздача ролей ─────────────────────────────────────────────────────────
  if (phase.phase === "roles") {
    return (
      <div className="w-full animate-slide-up" style={{ textAlign: "center" }}>
        <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: tv ? "1.3rem" : "0.85rem", color: "#aaa" }}>
          Раунд {phase.round}/{phase.max_rounds}
        </div>

        <div style={{ fontSize: tv ? "4rem" : "2.5rem", margin: tv ? "1rem 0" : "0.75rem 0" }}>🕵️</div>

        <div style={{
          fontFamily: "'Fredoka One',sans-serif",
          fontSize: tv ? "2.2rem" : "1.4rem",
          color: "#fff", textShadow: "2px 2px 0 #000",
        }}>
          Роли розданы!
        </div>

        <div style={{
          background: "#1a1a00", border: "2px solid #ffe600",
          borderRadius: "0.85rem", padding: tv ? "0.75rem 1.5rem" : "0.5rem 1rem",
          display: "inline-block", marginTop: tv ? "1.25rem" : "1rem",
        }}>
          <div style={{ fontFamily: "'Nunito',sans-serif", fontSize: tv ? "1rem" : "0.75rem", color: "#ffe600" }}>
            📱 Посмотрите роль на своём телефоне — не показывайте соседу!
          </div>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "center", marginTop: tv ? "1rem" : "0.75rem" }}>
          {(phase.players || []).map(p => (
            <div key={p} style={{
              background: "#1a0535", border: `2px solid ${COLOR}55`, borderRadius: "0.75rem",
              padding: tv ? "0.5rem 1.1rem" : "0.3rem 0.75rem",
              fontFamily: "'Fredoka One',sans-serif", fontSize: tv ? "1rem" : "0.8rem", color: "#fff",
            }}>
              {p}
            </div>
          ))}
        </div>
      </div>
    );
  }

  // ── Выбор вопроса ─────────────────────────────────────────────────────────
  if (phase.phase === "choosing") {
    return (
      <div className="w-full animate-slide-up" style={{ textAlign: "center" }}>
        <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: tv ? "1.5rem" : "1rem", color: "#aaa" }}>
          Вопрос {(phase.asker_idx || 0) + 1} из {phase.players_total}
        </div>
        <div style={{
          background: "#1a0535", border: `3px solid ${COLOR}`, borderRadius: "1.25rem",
          padding: tv ? "1.5rem 2rem" : "1rem 1.25rem", marginTop: tv ? "1rem" : "0.75rem",
          display: "inline-block",
        }}>
          <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: tv ? "2rem" : "1.3rem", color: "#ffe600" }}>
            {phase.asker}
          </div>
          <div style={{ fontFamily: "'Nunito',sans-serif", fontSize: tv ? "1.1rem" : "0.8rem", color: "#aaa", marginTop: 4 }}>
            выбирает вопрос и кому задать...
          </div>
        </div>
      </div>
    );
  }

  // ── Задаётся вопрос ───────────────────────────────────────────────────────
  if (phase.phase === "answering") {
    return (
      <div className="w-full animate-slide-up" style={{ textAlign: "center" }}>
        <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: tv ? "1.2rem" : "0.8rem", color: "#aaa" }}>
          Вопрос {(phase.asker_idx || 0) + 1} из {phase.players_total}
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem", marginTop: 8 }}>
          <span style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: tv ? "1.4rem" : "0.95rem", color: "#ffe600" }}>
            {phase.asker}
          </span>
          <span style={{ fontFamily: "'Nunito',sans-serif", color: "#888", fontSize: tv ? "1.1rem" : "0.8rem" }}>
            спрашивает
          </span>
          <span style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: tv ? "1.4rem" : "0.95rem", color: COLOR }}>
            {phase.target}
          </span>
        </div>

        <div style={{
          background: "#0d0820", border: `3px solid ${COLOR}`,
          borderRadius: "1.5rem", boxShadow: `6px 6px 0 #000`,
          padding: tv ? "2rem 2.5rem" : "1.25rem 1.5rem",
          maxWidth: tv ? 700 : "100%", margin: tv ? "1.5rem auto 0" : "1rem auto 0",
        }}>
          <div style={{
            fontFamily: "'Fredoka One',sans-serif",
            fontSize: tv ? "2.5rem" : "1.5rem",
            color: "#fff", textShadow: "2px 2px 0 #000",
            lineHeight: 1.3,
          }}>
            «{phase.question}»
          </div>
        </div>

        <div style={{ marginTop: tv ? "1rem" : "0.75rem" }}>
          <Timer seconds={phase.seconds} total={20} />
          <div style={{ fontFamily: "'Nunito',sans-serif", fontSize: tv ? "1rem" : "0.75rem", color: "#888", marginTop: 6 }}>
            {phase.target} отвечает вслух
          </div>
        </div>
      </div>
    );
  }

  // ── Обсуждение ────────────────────────────────────────────────────────────
  if (phase.phase === "discussion") {
    return (
      <div className="w-full animate-slide-up" style={{ textAlign: "center" }}>
        <div style={{ fontSize: tv ? "3rem" : "2rem" }}>💬</div>
        <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: tv ? "2rem" : "1.25rem", color: "#fff", marginTop: 8 }}>
          Обсуждайте!
        </div>
        <div style={{ fontFamily: "'Nunito',sans-serif", fontSize: tv ? "1.1rem" : "0.8rem", color: "#aaa", marginTop: 8 }}>
          Кто шпион? Шпион может назвать локацию досрочно!
        </div>
        <Timer seconds={phase.seconds} total={15} />
      </div>
    );
  }

  // ── Голосование ───────────────────────────────────────────────────────────
  if (phase.phase === "vote") {
    const voted = voteData?.voted || 0;
    const total = voteData?.total || (players?.length || 0);
    const voteCounts = voteData?.vote_counts || {};
    const maxVotes = Math.max(1, ...Object.values(voteCounts));

    return (
      <div className="w-full animate-slide-up">
        <div style={{ textAlign: "center", marginBottom: tv ? "1.5rem" : "1rem" }}>
          <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: tv ? "1.8rem" : "1.1rem", color: "#fff" }}>
            🗳️ Кто шпион?
          </div>
          <div style={{ fontFamily: "'Nunito',sans-serif", fontSize: tv ? "1rem" : "0.75rem", color: "#888", marginTop: 4 }}>
            Проголосовали: {voted}/{total}
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 8, maxWidth: 500, margin: "0 auto" }}>
          {(phase.players || []).map(p => {
            const cnt = voteCounts[p] || 0;
            const pct = (cnt / maxVotes) * 100;
            return (
              <div key={p} style={{
                background: "#1a0535", border: `1.5px solid ${COLOR}55`,
                borderRadius: "0.75rem", padding: tv ? "0.75rem 1rem" : "0.5rem 0.75rem",
                overflow: "hidden", position: "relative",
              }}>
                <div style={{
                  position: "absolute", left: 0, top: 0, bottom: 0,
                  width: `${pct}%`, background: `${COLOR}22`, transition: "width .4s ease",
                }} />
                <div style={{ position: "relative", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontFamily: "'Fredoka One',sans-serif", color: "#fff", fontSize: tv ? "1.1rem" : "0.85rem" }}>
                    {p}
                  </span>
                  {cnt > 0 && (
                    <span style={{ fontFamily: "'Fredoka One',sans-serif", color: "#ffe600", fontSize: tv ? "1.2rem" : "0.9rem" }}>
                      {cnt}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <Timer seconds={phase.seconds} total={20} />
      </div>
    );
  }

  // ── Шпион угадывает ───────────────────────────────────────────────────────
  if (phase.phase === "spy_guessing") {
    return (
      <div className="w-full animate-slide-up" style={{ textAlign: "center" }}>
        <div style={{ fontSize: tv ? "3rem" : "2rem" }}>🕵️</div>
        <div style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: tv ? "2rem" : "1.25rem", color: SPY_COLOR, marginTop: 8 }}>
          Шпион угадывает локацию!
        </div>
        {phase.early && (
          <div style={{ fontFamily: "'Nunito',sans-serif", fontSize: tv ? "1rem" : "0.75rem", color: "#aaa", marginTop: 6 }}>
            Досрочная попытка — риск ради +300 очков!
          </div>
        )}
      </div>
    );
  }

  return null;
}